export default "__VITE_ASSET__DJa1MOZe__"